// @flow
import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { isMobile } from 'react-device-detect';
import publicActions from 'actions/public';
import buildDeepLinkToGetStartedButton from '../../../utils/deepLinksManager';

import {
  GetStartedContainerDark,
  FullPhoneNumberContainer,
  CountryCodeText,
  PhoneNumberInput,
  SendButton,
  GetStartedButton,
  GetStartedLink,
  StandardRates,
} from './Styles';

const GetStarted = (props) => {
  const [pageState, updatePageState]: [any, ((any => any) | any) => void] = useState(
    {
      showGetStartedButton: true,
      showFullComponent: false,
      phoneNumber: '',
      inputHasError: false,
      buttonText: 'Send',
    },
  );

  const [containerErrorState, updateContainerErrorState]: [any, ((any => any) | any) => void] = useState(
    {
      containerHasError: false,
    },
  );

  const SendDownloadLink = async (phoneNumber) => {
    const newState = {};

    const plainPhoneNumber = phoneNumber.replace(/\D/g, '');

    await publicActions.sendDownloadAppLinkOnSMS({ phone: plainPhoneNumber })
      .then(() => {
        if (pageState.inputHasError) {
          newState.inputHasError = false;
        }

        newState.buttonText = 'Send';

        updatePageState({ ...pageState, ...newState });
      })
      .catch(() => {
        newState.buttonText = 'Resend';
        newState.inputHasError = true;

        updateContainerErrorState({ ...containerErrorState, containerHasError: true });

        updatePageState({ ...pageState, ...newState });
      });

    setTimeout(() => {
      updateContainerErrorState({ ...pageState, containerHasError: false });
    }, 1000);
  };

  // const onChangePhoneNumber = (e) => {
  //   if (e.target.value.length > 10) {
  //     updatePageState({ ...pageState, phoneNumber: e.target.value.substr(0, 10) });
  //     e.target.value = e.target.value.substr(0, 10);
  //   } else {
  //     updatePageState({ ...pageState, phoneNumber: e.target.value });
  //   }
  // };

  const onSend = () => {
    if (pageState.phoneNumber === '') {
      updateContainerErrorState({ ...containerErrorState, containerHasError: true });

      setTimeout(() => {
        updateContainerErrorState({ ...containerErrorState, containerHasError: false });
      }, 500);
    } else {
      updatePageState({ ...pageState, buttonText: 'Sending...' });

      SendDownloadLink(pageState.phoneNumber);
    }
  };

  const onKeyPressPhoneNumber = (e) => {
    if (e.target.value.length > 13) {
      e.preventDefault();
      return false;
    }

    return true;
  };

  const onInputPhoneNumber = (e) => {
    const groups = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    const phone = !groups[2] ? groups[1] : `(${groups[1]}) ${groups[2]}${groups[3] ? `-${groups[3]}` : ''}`;

    updatePageState({ ...pageState, phoneNumber: phone });
  };

  const onClickGetStartedButton = () => {
    updatePageState({ ...pageState, showFullComponent: true, showGetStartedButton: false });

    const menuMobile = document.getElementsByClassName('main-menu')[0];

    if (menuMobile) {
      menuMobile.classList.add('get-started-openned');
    }
  };

  if (isMobile) {
    return (
      <GetStartedLink
        className="mobile-only"
        target="_blank"
        href={buildDeepLinkToGetStartedButton()}
      >
        Get Started
      </GetStartedLink>
    );
  }

  return (
    <>
      <CSSTransition
        in={pageState.showFullComponent}
        timeout={1500}
        classNames="alert"
        unmountOnExit
      >
        <>
          <GetStartedContainerDark
            className={containerErrorState.containerHasError ? 'with-error' : ''}
          >
            <FullPhoneNumberContainer
              borderColor="17BFDD"
            >
              <CountryCodeText
                color="#17BFDD"
              >
                (US +1)

              </CountryCodeText>
              <PhoneNumberInput
                className={pageState.inputHasError ? 'with-error' : ''}
                // onChange={(e) => onChangePhoneNumber(e)}
                value={pageState.phoneNumber}
                onInput={(e) => onInputPhoneNumber(e)}
                placeholder="Phone Number"
                type="text"
                placeholderColor="grey"
                onKeyPress={(e) => onKeyPressPhoneNumber(e)}
              />
            </FullPhoneNumberContainer>
            <SendButton onClick={() => onSend()} foregroundColor="white" backgroundColor="#17BFDD">
              {pageState.buttonText}
            </SendButton>
          </GetStartedContainerDark>
          <StandardRates>Standard rates may apply</StandardRates>
        </>
      </CSSTransition>
      {
      pageState.showGetStartedButton
      && (
        <GetStartedButton
          onClick={() => onClickGetStartedButton()}
        >
          Get Started
        </GetStartedButton>
      )
    }
    </>
  );
};

export default GetStarted;
